export default [
  {
    path: '/app/admin/map',
    name: 'mapMarkerAdmin',
    components: {
      default: () => import('../../views/mapDevice/indexAdmin.vue')
    }
  },
  {
    path: '/app/admin/map/multipleView',
    name: 'multipleViewAdmin',
    components: {
      default: () => import('../../views/viewMulti/indexAdmin.vue')
    }
  },
  {
    path: '/app/admin/monitoring',
    name: 'MonitorViewAdmin',
    components: {
      default: () => import('../../views/monitor/indexMonitor.vue')
    }
  },
  {
    path: '/app/admin/ftp',
    name: 'ftpPagesAdmin',
    components: {
      default: () => import('../../views/ftp/indexFtpAdmin.vue')
    }
  },
  {
    path: '/app/admin/ftp/history',
    name: 'ftpHistoryAdmin',
    components: {
      default: () => import('../../views/ftp/indexFtpHistoryAdmin.vue')
    }
  },
  {
    path: '/app/admin/integration/nature',
    name: 'natureSettingsAdmin',
    components: {
      default: () => import('../../views/integration/natureSettings.vue')
    }
  },
  {
    path: '/app/admin/integration/mqtt',
    name: 'mqttSettingsAdmin',
    components: {
      default: () => import('../../views/integration/mqttSettings.vue')
    }
  },
  {
    path: '/app/admin/integration/uc300',
    name: 'uc300DevicesAdmin',
    components: {
      default: () => import('../../views/integration/uc300Devices.vue')
    }
  },
  {
    path: '/app/admin/integration/neuron-remote',
    name: 'neuronRemoteAdmin',
    components: {
      default: () => import('../../views/integration/neuronRemote.vue')
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/mapAdmin.js